import React, { useState, useRef, useEffect } from 'react';
import '../utils/image-compare.css';

const ImageCompare = ({ beforeImage, afterImage }) => {

  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);
  const [beforeImageUrl, setBeforeImageUrl] = useState(null);
  const [afterImageUrl, setAfterImageUrl] = useState(null);

  // Convert File or base64 to URL
  useEffect(() => {
    let url = null;
    
    if (beforeImage) {
      if (beforeImage instanceof File) {
        url = URL.createObjectURL(beforeImage);
        setBeforeImageUrl(url);
      } else if (typeof beforeImage === 'object' && beforeImage.data) {
        url = `data:image/png;base64,${beforeImage.data}`;
        setBeforeImageUrl(url);
      } else {
        setBeforeImageUrl(null);
      }
    } else {
      setBeforeImageUrl(null);
    }
    
    return () => {
      if (url && beforeImage instanceof File) {
        URL.revokeObjectURL(url);
      }
    };
  }, [beforeImage]);

  useEffect(() => {
    let url = null;
    
    if (afterImage) {
      if (afterImage instanceof File) {
        url = URL.createObjectURL(afterImage);
        setAfterImageUrl(url);
      } else if (typeof afterImage === 'object' && afterImage.data) {
        url = `data:image/png;base64,${afterImage.data}`;
        setAfterImageUrl(url);
      } else {
        setAfterImageUrl(null);
      }
    } else {
      setAfterImageUrl(null);
    }
    
    return () => {
      if (url && afterImage instanceof File) {
        URL.revokeObjectURL(url);
      }
    };
  }, [afterImage]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    e.preventDefault();
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    setSliderPosition(Math.max(0, Math.min(100, percentage)));
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    e.preventDefault();
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    
    const rect = containerRef.current.getBoundingClientRect();
    const touch = e.touches[0];
    const x = touch.clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    setSliderPosition(Math.max(0, Math.min(100, percentage)));
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };



  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleTouchMove);
      document.addEventListener('touchend', handleTouchEnd);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
      };
    }
  }, [isDragging]);

  if (!beforeImageUrl || !afterImageUrl) {
    return <div className="image-compare-loading">Loading images...</div>;
  }



  return (
    <div 
      className="image-compare-container"
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
    >
      {/* Before Image (Full) */}
      <div className="image-compare-before">
        <img 
          src={beforeImageUrl} 
          alt="Before" 
        />
      </div>
                    
      {/* After Image (Clipped) */}
      <div 
        className="image-compare-after"
        style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
      >
        <img 
          src={afterImageUrl} 
          alt="After" 
        />
      </div>
      
      {/* Slider Handle */}
      <div 
        className="image-compare-slider"
        style={{ left: `${sliderPosition}%` }}
      >
        <div className="slider-line"></div>
        <div className="slider-handle-circle"></div>
      </div>
      
      {/* Labels */}
      <div className="image-compare-label before-label">Before</div>
      <div className="image-compare-label after-label">After</div>
    </div>
  );
};

export default ImageCompare; 